export default __webpack_public_path__ + "static/media/solar.afa61cd5.jpg";